import { useQuery } from '@tanstack/react-query';
import { getCancellationDetails } from '../api';
import { CACHE_CONFIG } from '../constants';
import { transformCancellationData } from '../utils/formatters';

/**
 * Hook for fetching and caching contract cancellation details.
 *
 * Uses TanStack Query for data fetching with 5-minute caching to reduce
 * server load. The hook is enabled only when a modal is open and a valid
 * contract ID is provided.
 *
 * @param contractNumber - The contract number to fetch details for
 * @param enabled - Whether the query should be enabled (typically when modal is open)
 * @returns Query result with transformed cancellation data
 */
export function useCancellationDetails(
  contractNumber: string,
  enabled: boolean
) {
  return useQuery({
    queryKey: ['cancellationDetails', contractNumber],
    queryFn: async () => {
      const rawData = await getCancellationDetails(contractNumber);
      return transformCancellationData(rawData);
    },
    enabled: enabled && !!contractNumber,
    staleTime: CACHE_CONFIG.STALE_TIME,
    gcTime: CACHE_CONFIG.GC_TIME,
  });
}
